var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pin (1) 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7 0C4.7384 0 2.89844 1.83996 2.89844 4.10156C2.89844 6.17777 4.44913 7.89838 6.45312 8.16657V13.4531C6.45312 13.7552 6.69796 14 7 14C7.30204 14 7.54688 13.7552 7.54688 13.4531V8.16657C9.55084 7.89838 11.1016 6.17777 11.1016 4.10156C11.1016 1.83996 9.2616 0 7 0ZM7 7.10938C5.34149 7.10938 3.99219 5.76007 3.99219 4.10156C3.99219 2.44305 5.34149 1.09375 7 1.09375C8.65851 1.09375 10.0078 2.44305 10.0078 4.10156C10.0078 5.76007 8.65851 7.10938 7 7.10938Z",
    fill: "#979EA8"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon1);
export default __webpack_public_path__ + "static/media/pinIcon_1.86239898c26b3203db3ea6708610f1b7.svg";
export { ForwardRef as ReactComponent };